<template>
  <footer class="footer">
    <div class="wrap">
      <div class="ft_link">
        <div class="box_wrap" v-for="item in list" :key="item.id">
          <div class="title">{{ item.title }}</div>
          <router-link
            :to="`/newdetail/${child.id}`"
            v-for="child in item.newsList"
            :key="child.id"
            >{{ child.title }}</router-link
          >
        </div>
        <div class="box_wrap er_code">
          <div class="title">APP下载</div>
          <div class="app_ercode" id="app_ercode">
            <img src="@/assets/app-download.png" alt="" />
          </div>
        </div>
      </div>
      <div class="ft_info">
        <div>
          <span>Powered by 默默通信息科技 - </span>
          <router-link to="/">https://www.momoton.com</router-link>
          <span> 版权所有 </span>
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >湘ICP备17022416号-2</a
          >
        </div>
        <div>
          部分内容来自互联网，若无意中侵权请联系
          514670796@qq.com，我们将于48小时之内删除相关内容
        </div>
        <div>
          ©2017-{{ new Date().getFullYear() }} All Rights Reserved
          长沙默默通信息科技有限公司
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import services from '@/services'
export default {
  data () {
    return {
      list: []
    }
  },
  created () {
    this.getNewsInfo4BottomFid()
  },
  methods: {
    async getNewsInfo4BottomFid () {
      try {
        const { status, info } = await services.index.getNewsInfo4BottomFid()
        if (status) {
          this.list = info || []
        }
      } catch (error) {
        this.$message.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';
.footer {
  min-height: 300px;
  background-color: #474747;

  .wrap {
    width: 1190px;
    margin: 0 auto;

    .ft_link {
      padding: 20px 0;
      display: flex;
      justify-content: space-between;

      .box_wrap {
        width: 220px;
        margin-top: 10px;
        border-right: 1px solid #eaecef;

        .title {
          color: #fff;
          font-size: 16px;
          font-weight: bold;
          padding-bottom: 10px;
        }

        a {
          display: block;
          width: 200px;
          padding: 5px 0;
          color: #fff;
          text-decoration: none;
          font-size: 12px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;

          &:hover {
            color: $--color-primary;
          }
        }

        &.er_code {
          width: 130px;
          border-right: none;

          .app_ercode {
            img {
              display: block;
              width: 130px;
            }
          }
        }
      }
    }

    .ft_info {
      padding: 30px 0 20px 0;
      text-align: center;
      color: #fff;
      font-size: 12px;

      & > div {
        padding: 5px 0;
      }

      a {
        color: $--color-primary;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
